import React, { useEffect, useState } from 'react';
import { fetchPlans, formatPlan, startCheckout } from '../checkout';

/**
 * The upgrade call-to-action inside the Premium upsell modals. When subscription
 * plans are configured for this environment (Stripe set up), it shows real
 * "Upgrade" buttons that open Stripe Checkout; otherwise it falls back to the honest
 * "coming soon" note, so production stays unchanged until Stripe is live. Drops in
 * where the old static note lived, using the shared cd-upsell-* styles.
 */
export default function UpgradeOptions() {
  const [plans, setPlans] = useState(null);   // null = still loading
  const [busy, setBusy]   = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    let alive = true;
    fetchPlans().then(p => { if (alive) setPlans(p); });
    return () => { alive = false; };
  }, []);

  if (plans === null) return null;            // render nothing while loading
  if (plans.length === 0) {
    return <p className="cd-upsell-note">Upgrade options are coming soon.</p>;
  }

  const buy = async (priceId) => {
    setBusy(true);
    setError('');
    const r = await startCheckout(priceId);   // redirects away on success
    if (!r.ok) {
      setError(r.error);
      setBusy(false);
    }
  };

  return (
    <div className="cd-upsell-plans">
      {plans.map(plan => (
        <button
          key={plan.price_id}
          type="button"
          className="cd-upsell-cta"
          disabled={busy}
          onClick={() => buy(plan.price_id)}
        >
          {busy ? 'Starting…' : `Upgrade — ${formatPlan(plan)}`}
        </button>
      ))}
      {error && <p className="cd-upsell-err">{error}</p>}
    </div>
  );
}
